import {Component, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, UntypedFormGroup, Validators} from '@angular/forms';
import {CustomValidationError} from 'projects/mydocma/dynamic-form/src/lib/validation/custom-validation-error';
import {DynamicFormConfig} from 'projects/mydocma/dynamic-form/src/lib/dynamic-form/dynamic-form.config';
import {
    FieldTypeEnum,
    MultipleOptionType
} from '../../../../projects/mydocma/dynamic-form/src/lib/dynamic-field/field-type.enum';
import {TextFieldConfig} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/text/text-field.config';
import {DynamicFormReadyEvent} from '../../../../projects/mydocma/dynamic-form/src/lib/events/dynamic-form-ready.event';
import {
    MultiOptionConfig
} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/multi-option/multi-option.config';
import {
    FieldOrientationEnum,
    LabelPositionEnum
} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/multi-option/multi-field.enums';
import {
    DividerFieldConfig
} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/divider/divider-field.config';
import {
    LabelDividerPositionEnum
} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/divider/label-divider-position.enum';
import {DateFieldConfig} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/date/date-field.config';
import {NumberFieldConfig} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/number/number-field.config';
import {ValuePositionEnum} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/number/value-position.enum';
import {TimeFieldConfig} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/time/time-field.config';
import {LabelFieldConfig} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/label/label-field.config';
import {ChipsFieldConfig} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/chips/chips-field.config';
import {ChipsMultiSelectFieldConfig} from '../../../../projects/mydocma/dynamic-form/src/lib/fields/chips-multiselect/chips-multiselect-field.config';
import {ChipListViewTypeEnum} from '@mydocma/component-library/src/lib/chips';
import { TextAreaFieldConfig } from 'projects/mydocma/dynamic-form/src/public-api';

@Component({
    selector: 'app-create-task',
    templateUrl: './form-interaction.component.html',
    styleUrls: ['./form-interaction.component.scss']
})
export class FormInteractionComponent implements OnInit {

    @ViewChild('fieldsTextArea', {static: true})
    public fieldsTextArea;

    public defaultFields = [
        {
            id: 'date1',
            name: 'date1',
            placeholder: 'date11',
            type: FieldTypeEnum.date,
            label: {text: 'date1'},
            required: true,
            readonly: false,
            minDate: new Date(2022, 9, 1),
            spinner: true,
            showTodayButton: true,

        } as DateFieldConfig,
        {
            id: 'date7',
            name: 'date7',
            type: FieldTypeEnum.date,
            label: {text: 'date7'},
            required: true,
            readonly: true,
            maxDate: new Date(2021, 11, 20),
            showTodayButton: true, spinner: true,
        } as DateFieldConfig,
        {
            id: 'company',
            name: 'company',
            type: FieldTypeEnum.text,
            placeholder: 'companyLabel1',
            label: {text: 'companyLabel1'},
            required: false
        } as TextFieldConfig,

        {
            id: 'text1',
            name: 'text1',
            type: FieldTypeEnum.text,
            label: {text: 'text1'},
            class: 'additional-class',
            required: false,
            maxLength: 12,
            minLength: 3,
            validators: [this.badWordValidator.bind(this)],
            asyncValidators: [this.allBadWordValidator.bind(this)]
        } as TextFieldConfig,
        {
            id: 'dividerLabel',
            name: 'dividerLabel',
            type: FieldTypeEnum.divider,
            label: {text: 'companyLabel'},
            labelPosition: LabelDividerPositionEnum.right,
            lineWidth: 1
        } as DividerFieldConfig,
        {
            id: 'slideToggle24',
            name: 'slideToggle24',
            type: FieldTypeEnum.multiOption,
            label: {text: 'slideToggles'},
            class: 'additional-class',
            optionType: MultipleOptionType.slideToggle,
            source: {
                option1: {text: 'fields.slideGroup.kyiv', readonly: true},
                option2: 'fields.slideGroup.lviv',
                option3: 'fields.slideGroup.cherkassy'
            },
            value: {
                option1: true,
                option2: true,
                option3: true
            },
            outlineHidden: false,
            orientation: FieldOrientationEnum.horizontal,
            labelPosition: LabelPositionEnum.after
        } as MultiOptionConfig,
        {
            id: 'checkboxGroup',
            name: 'checkboxGroup',
            type: FieldTypeEnum.multiOption,
            label: {text: 'checkboxGroup'},
            class: 'additional-class',
            optionType: MultipleOptionType.checkBox,
            source: {
                checkbox1: 'fields.optionGroup.coffee',
                checkbox2: 'fields.optionGroup.tea',
                checkbox3: 'fields.optionGroup.milk'
            },
            value: {checkbox1: true},
            orientation: FieldOrientationEnum.vertical,
            labelPosition: LabelPositionEnum.after
        } as MultiOptionConfig,
        {
            id: 'textarea1',
            name: 'textarea1',
            type: FieldTypeEnum.textarea,
            label: {text: 'textarea1'},
            required: true,
            maxLength: 12,
            minLength: 2,
            maxRows: 10,
            minRows: 2,            
            validators: [this.badWordValidator.bind(this)],
            asyncValidators: [this.allBadWordValidator.bind(this)]
        } as TextAreaFieldConfig,
        {
            id: 'number1',
            name: 'number1',
            type: FieldTypeEnum.number,
            label: {text: 'number1'},
            required: true,
            readonly: false,
            maxValue: 12,
            incrementButtons: true,
            valuePosition: ValuePositionEnum.center,
            clearButtonVisibility: false,
            disabled: true
        } as NumberFieldConfig,
        {
            id: 'select1',
            name: 'select1',
            type: FieldTypeEnum.select,
            label: {text: 'select1'},
            required: true,
            source: [{text: 'item1', id: '1'}, {text: 'item2', id: '2'}]
        },
        {
            id: 'select4',
            name: 'select4',
            type: FieldTypeEnum.filterSelect,
            label: {text: 'FilterSelect'},
            required: true,
            source: [{text: 'item1', id: '1'}, {text: 'item2', id: '2'}]
        },
        {
            id: 'checkbox1',
            name: 'checkbox1',
            type: FieldTypeEnum.checkbox,
            label: {text: 'checkbox1'},
            required: true,
            validators: [Validators.required]
        },
        {
            id: 'chips',
            name: 'chip-list',
            type: FieldTypeEnum.chips,
            label: {text: 'chip list 1'},
            validators: Validators.email,
            required: true,
            readonly: false,
            // asyncValidators: [this.allBadWordValidator.bind(this)],
            options: {
                hideRemoveAll: false,
                viewType: ChipListViewTypeEnum.multiLine,
                addNewOptions: {
                    startAdding: 1
                }
            },
            value: [{id: 'apple', text: 'Apple'}]
        } as ChipsFieldConfig,
        {
            id: 'chipsMultiSelect',
            name: 'chipsMultiSelect',
            type: FieldTypeEnum.chipsMultiSelect,
            label: {text: 'chips multi select'},
            required: false,
            readonly: false,
            options: {
                openDropdownOnClick: true,
                maxRows: 5
            },
            source: [
                {id: 'apple', label: 'Apple'},
                {id: 'banana', label: 'Banana'},
                {id: 'cherry', label: 'Cherry'},
                {id: 'date', label: 'Date'},
                {id: 'elderberry', label: 'Elderberry'},
                {id: 'fig', label: 'Fig'},
                {id: 'grape', label: 'Grape'},
                {id: 'honeydew', label: 'Honeydew'},
                {id: 'kiwi', label: 'Kiwi'},
                {id: 'lemon', label: 'Lemon'},
                {id: 'mango', label: 'Mango'},
                {id: 'nectarine', label: 'Nectarine'}
            ],
            value: [
                {id: 'apple', label: 'Apple'},
                {id: 'banana', label: 'Banana'},
                {id: 'cherry', label: 'Cherry'},
                {id: 'grape', label: 'Grape'},
                {id: 'mango', label: 'Mango'}
            ]
        } as ChipsMultiSelectFieldConfig,
        {
            id: 'date4',
            name: 'date4',
            type: FieldTypeEnum.date,
            label: {text: 'date1'},
            required: true,
            readonly: true,
            minDate: new Date(2021, 1, 1),
            showTodayButton: true, spinner: true,
        } as DateFieldConfig,
        {
            id: 'date5',
            name: 'date5',
            type: FieldTypeEnum.date,
            label: {text: 'date2'},
            required: true,
            readonly: true,
            maxDate: new Date(2022, 0, 1),
            showTodayButton: true, spinner: true,
        } as DateFieldConfig,
        {
            id: 'datetime1',
            name: 'datetime1',
            label: {text: 'datetime1'},
            type: FieldTypeEnum.datetime,
            minDate: new Date(2022, 9, 1, 23, 31),
            value: new Date(2022, 9, 1, 1, 30),
            required: true,
        },
        {
            id: 'time1',
            name: 'time1',
            type: FieldTypeEnum.time,
            label: {text: 'time1'},
            required: true,
            readonly: true,
            // disabled: true,
            // minHours: '23:00',
            // maxHours: '23:50'
        } as TimeFieldConfig,
        {
            id: 'button1',
            name: 'button1',
            type: FieldTypeEnum.button,
            label: {text: 'button1'},
            required: true,
        },
        {
            id: 'icon1',
            name: 'icon1',
            type: FieldTypeEnum.icon,
            label: {text: 'icon1'},
            required: true,
            value: 'search'
        },
        {
            id: 'image1',
            name: 'image1',
            type: FieldTypeEnum.image,
            label: {text: 'image1'},
            width: '400px',
            height: '300px',
            value: 'https://i.ytimg.com/vi/1Ne1hqOXKKI/maxresdefault.jpg'
        },
        {
            id: 'label1',
            name: 'label1',
            type: FieldTypeEnum.label,
            label: {text: 'label1'},
            onLabelClick: () => alert(4),
            value: 'London is the capital of Great Britain, sadasdasdadaks dkakdakkaskdasd kakdkaskdakdkas',
        } as LabelFieldConfig,
        {
            id: 'option1',
            name: 'option1',
            type: FieldTypeEnum.option,
            label: {text: 'option1'},
            required: true,
            orientation: 'vertical',
            options: [{optionLabel: 'Paris', optionValue: 'Paris'},
                {optionLabel: 'London', optionValue: 'London'}]
        },
        {
            id: 'toggle-slide',
            name: 'slidetoggle1',
            type: FieldTypeEnum.slidetoggle,
            label: {text: 'slidetoggle1'},
            required: true,
        }
    ];

    public formConfig: DynamicFormConfig;

    public fieldsAreaOldValue = JSON.stringify(this.defaultFields);
    public fieldsAreaNewValue;
    public fieldsAreaError = false;

    private formData: DynamicFormReadyEvent;
    private formGroup: UntypedFormGroup;

    public ngOnInit() {
        const fieldsAreaOldValue = localStorage.getItem('interactionFieldConfig') || this.fieldsAreaOldValue;
        if (fieldsAreaOldValue) {
            this.fieldsAreaOldValue = this.createFieldsData(fieldsAreaOldValue);
        }

        this.formConfig = {
            layouts: [],
            fields: this.defaultFields
        };
    }

    public onReady(param: DynamicFormReadyEvent) {
        this.formData = param;
        this.formGroup = param.dynamicFormService.formGroup;

        this.formData.dynamicFormEventsService.onFieldValueChanged.subscribe((event: any) => {
            console.log('onFieldValueChanged', event);
        });
    }

    public setFieldsArea(fieldsAreaValue) {
        if (!fieldsAreaValue) {
            return;
        }

        localStorage.setItem('interactionFieldConfig', fieldsAreaValue);
    }

    public updateFieldConfig() {
        let fieldsArea = this.fieldsAreaNewValue || this.fieldsAreaOldValue;
        this.setFieldsArea(fieldsArea);

        if (typeof fieldsArea !== 'object') {
            fieldsArea = JSON.parse(fieldsArea);
        }
        delete fieldsArea.validators;
        delete fieldsArea.asyncValidators;

        this.formData.dynamicFormService.updateFieldConfig(fieldsArea);
    }

    public fieldsAreaChange(data) {
        this.fieldsAreaNewValue = data;

        this.fieldsAreaError = false;
        try {
            if (data) {
                JSON.parse(data);
            }
        } catch (e) {
            this.fieldsAreaError = true;
        }
    }

    private badWordValidator(control: AbstractControl): CustomValidationError {
        if (control.value && control.value.toLowerCase() === 'bad word') {
            return {
                mydocmaCustomError: 'bad words are not allowed'
            };
        }
    }

    private async allBadWordValidator(control: AbstractControl): Promise<CustomValidationError> {
        if (control.value && control.value.toLowerCase().trim().startsWith('all bad word')) {
            return {
                mydocmaCustomError: 'all bad words are not allowed'
            };
        }
    }

    private createFieldsData(data) {
        if (!data) {
            return [];
        }

        return typeof data === 'string'
            ? JSON.parse(data)
            : data;
    }
}
